export { default as SwAppIcon } from './sw-app-icon.vue';
export * from './assets/images/apps/name-id-map';
